<template>
  <div class="hm-spec-value-selector">
    <el-dialog
      title="选择规格值"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="900px"
      @closed="handleClosed"
    >
      <div class="mb10">
        <el-input
          v-model.trim="keyword"
          size="small"
          placeholder="输入规格值关键字搜索"
          style="width: 260px"
          @input="filterList"
        ></el-input>
        <span class="ml10">已选 {{ selectedCount }} 项</span>
      </div>
      <el-table
        ref="table"
        :data="pagedList"
        height="400"
        row-key="valueId"
      >
        <el-table-column width="55">
          <template slot-scope="{ row }">
            <el-checkbox :value="!!selectedIds[row.valueId]" @change="checked => handleCheck(row, checked)"></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column prop="specValue" label="规格值"></el-table-column>
      </el-table>
      <div class="hm-pagination mt10">
        <el-pagination
          background
          :total="filteredList.length"
          @current-change="handlePageChange"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page.sync="pageNo"
          :page-sizes="pageSizes"
          :page-size="pageSize"
        ></el-pagination>
      </div>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="confirm" size="small" type="primary">确认</el-button>
        <el-button @click="dialogVisible = false" size="small">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "HmSpecValueSelector",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    sourceList: {
      type: Array,
      default: () => []
    },
    selectedList: {
      type: Array,
      default: () => []
    },
    pageSizes: {
      type: Array,
      default: () => [20, 50, 100]
    }
  },
  data() {
    return {
      keyword: "",
      filteredList: [],
      selectedIds: {},
      pageSize: 50,
      pageNo: 1
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      }
    },
    pagedList() {
      const start = (this.pageNo - 1) * this.pageSize;
      return this.filteredList.slice(start, start + this.pageSize);
    },
    selectedCount() {
      return Object.keys(this.selectedIds).length;
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.openInit();
      }
    }
  },
  methods: {
    openInit() {
      this.keyword = "";
      this.pageNo = 1;
      this.filteredList = (this.sourceList || []).slice();
      this.selectedIds = {};
      (this.selectedList || []).forEach(o => {
        this.$set(this.selectedIds, o.valueId, true);
      });
    },
    filterList() {
      const keyword = this.keyword.toLowerCase();
      if (!keyword) {
        this.filteredList = (this.sourceList || []).slice();
      } else {
        this.filteredList = (this.sourceList || []).filter(item =>
          String(item.specValue || "").toLowerCase().includes(keyword)
        );
      }
      this.pageNo = 1;
    },
    handlePageChange() {
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.pageNo = 1;
    },
    handleCheck(row, checked) {
      if (checked) {
        this.$set(this.selectedIds, row.valueId, true);
      } else {
        this.$delete(this.selectedIds, row.valueId);
      }
    },
    confirm() {
      const result = (this.sourceList || []).filter(o => this.selectedIds[o.valueId]);
      this.$emit("confirm", result);
      this.dialogVisible = false;
    },
    handleClosed() {
      this.$emit("closed");
    }
  }
};
</script>
